import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ja from './locales/ja.json';
import en from './locales/en.json';

// Supported UI languages. Button labels are autonyms (shown in their own
// language), so they are intentionally NOT translated.
export const SUPPORTED_LANGUAGES = [
  { code: 'ja', label: '日本語' },
  { code: 'en', label: 'English' },
];
export const DEFAULT_LANGUAGE = 'ja'; // Japanese is the primary language
export const LANGUAGE_STORAGE_KEY = 'graphTutor::lang';

// Deterministic initial language: a previously-stored valid choice, otherwise
// Japanese. We never auto-switch based on the browser/navigator language.
function readStoredLanguage() {
  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (SUPPORTED_LANGUAGES.some((l) => l.code === stored)) return stored;
  } catch (e) {
    // localStorage may be unavailable (private mode); fall through to default.
  }
  return DEFAULT_LANGUAGE;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ja: { translation: ja },
      en: { translation: en },
    },
    lng: readStoredLanguage(),
    supportedLngs: ['ja', 'en'],
    // No cross-language fallback: a missing key surfaces LOUDLY (renders the key)
    // instead of silently showing the other language. EN/JA key parity is
    // enforced by `npm run i18n:check`, so the fallback never fires in practice.
    fallbackLng: false,
    detection: {
      order: ['localStorage'], // never use navigator/browser language
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'], // persist the choice on changeLanguage()
    },
    interpolation: { escapeValue: false }, // React already escapes
    returnNull: false,
    react: { useSuspense: false },
  });

export default i18n;
